import { WrenchTheme } from '@wds/styles';
import { merge } from 'lodash';

const changes = {
	palette: {
		name: 'Ice',
		primary: {
			main: '#00BCF1',
			contrast: '#FFFFFF',
			hover: '#009CF1',
		},
		success: {
			main: '#00BCF1',
			hover: '#009CF1',
		},
		muted: {
			main: '#D0D2D3',
			contrast: '#393939',
		},
	},
};

export const IceTheme = merge({}, WrenchTheme, changes);
